import apiClient from './api';

const fileService = {
  // 上传单个文档文件
  uploadDocument: async (file) => {
    const formData = new FormData();
    formData.append('document', file);
    const response = await apiClient.post('/files/document', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    console.log('[node.frontend.src.services.fileService.js]上传单个文档文件:', response.data);
    return response.data;
  },

  // 批量上传文档文件
  uploadMultipleFiles: async (files, type = 'document') => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    formData.append('type', type);
    const response = await apiClient.post('/files/batch', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    console.log('[node.frontend.src.services.fileService.js]批量上传文档文件:', response.data);
    return response.data;
  },
};

export default fileService; 